import { render, staticRenderFns } from "./InvE_Items.vue?vue&type=template&id=a80e9ff4"
import script from "./InvE_Items.vue?vue&type=script&lang=js"
export * from "./InvE_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports